/**
 * Admin de empresa (customers/{cid}.Usuarios[].isAdmin) y su espejo plano
 * customers/{cid}.AdminsUids (spec 2026-10-06 Fase 6): las reglas lo leen
 * con hasAny([uid]) para dejar a un admin de empresa escribir matrices.
 * Módulo puro.
 */
export const toggleAdmin = ({ usuarios, email } = {}) => {
  const users = (Array.isArray(usuarios) ? usuarios : []).map((u) => (u && typeof u === 'object' ? { ...u } : u));
  const index = users.findIndex((u) => u && u.email === email);
  if (index === -1) return null;
  const isAdminNow = users[index].isAdmin !== true;
  users[index].isAdmin = isAdminNow;
  return { users, index, uid: users[index].reference?.id || null, isAdminNow };
};

export const adminsUidsOf = (usuarios) => [...new Set(
  (Array.isArray(usuarios) ? usuarios : [])
    .filter((u) => u && u.isAdmin === true && u.reference && u.reference.id)
    .map((u) => u.reference.id),
)].sort();

export default toggleAdmin;
